import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ReactSelect from 'react-select'
import { InvoiceService } from '../../../services'
import { startFetch, endFetch } from '../../../actions/generalActions'
import ToastService from '../shared/Toast/ToastService'

class InvoiceValidationForm extends Component {
  state = {
    reprovedReasons: [],
    selectedReason: null,
    approved: null,
    errors: {},
  }

  componentDidMount() {
    this.fetchReasons()
  }

  // Only the refusal reasons exist as a resource (/invoice_reprove_reasons);
  // approve_invoice takes no reason, as in DefaultTemplate.
  fetchReasons = () => {
    const { client } = this.props
    InvoiceService.getReprovalReasons({ clientId: client.slug })
      .then(response => this.setState({ reprovedReasons: response.data.reprove_reasons || [] }))
      .catch(() => {})
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { campaign, client, match } = this.props
    const { approved, selectedReason } = this.state

    if (approved === null) {
      ToastService.error('Selecione uma opção de aprovação')
      return
    }
    if (!approved && !selectedReason) {
      ToastService.error('Selecione uma razão')
      return
    }

    const payload = {
      clientId: client.slug,
      campaignId: campaign.slug,
      id: match.params.id,
      selectedReason,
    }

    this.props.startFetch()
    const request = approved
      ? InvoiceService.approveInvoice(payload)
      : InvoiceService.refuseInvoice(payload)

    request
      .then(response => {
        this.props.endFetch()
        // The queues are held in ValidatorContainer's state, so they have to be
        // refetched before landing on the validated tab.
        if (this.props.onValidated) this.props.onValidated()
        const invoice = response.data && response.data.invoice
        this.props.history.push(invoice ? `/invoice/validated/${invoice.id}` : '/invoice/validated')
      })
      .catch(error => {
        this.props.endFetch()
        if (error.response && error.response.data) {
          this.setState({ errors: error.response.data })
        } else {
          ToastService.error('Erro ao validar a fatura')
        }
      })
  }

  handleApprove = (e) => {
    e.preventDefault()
    this.setState({ approved: true, selectedReason: null })
  }

  handleReprove = (e) => {
    e.preventDefault()
    this.setState({ approved: false, selectedReason: null })
  }

  render() {
    const { approved, reprovedReasons, selectedReason, errors } = this.state

    return (
      <form className="invoice-validation" onSubmit={this.handleSubmit}>
        <div className="invoice-form-section">
          <h5 className="invoice-form-section-title">Validar fatura</h5>
        </div>

        <div className="invoice-form-card">
          <div className="invoice-form-field invoice-validation-field">
            <span className="invoice-form-label">Decisão</span>
            <div className="invoice-validation-choices">
              <button
                type="button"
                onClick={this.handleApprove}
                className={`gl-button medium body-m ${approved === true ? 'primary' : 'secondary'}`}
              >
                Aprovar
              </button>
              <button
                type="button"
                onClick={this.handleReprove}
                className={`gl-button medium body-m ${approved === false ? 'primary' : 'secondary'}`}
              >
                Reprovar
              </button>
            </div>
          </div>

          {approved === false && (
            <div className="invoice-form-field invoice-validation-field">
              <label className="invoice-form-label">Razão de reprovação</label>
              <ReactSelect
                isClearable
                onChange={(val) => this.setState({ selectedReason: val })}
                options={reprovedReasons}
                value={selectedReason}
                getOptionLabel={(o) => o.name}
                getOptionValue={(o) => o.id}
                placeholder="Selecionar"
                className="invoice-form-select"
                classNamePrefix="invoice-select"
                noOptionsMessage={() => 'Sem opções'}
              />
              {errors.reprove_reason_id && (
                <p className="invoice-error">{errors.reprove_reason_id.join(', ')}</p>
              )}
            </div>
          )}
        </div>

        {approved !== null && (
          <div className="invoice-form-actions">
            <button className="gl-button primary medium body-m" type="submit">
              Guardar validação
            </button>
          </div>
        )}
      </form>
    )
  }
}

const mapStateToProps = (state) => ({
  client: state.userReducer.client,
})

const mapDispatchToProps = (dispatch) => ({
  startFetch: () => dispatch(startFetch()),
  endFetch: () => dispatch(endFetch()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoiceValidationForm))
